module.exports = __webpack_public_path__ + "c988376768a6c41bdc0a8bae8d74f239.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/vaillant.png
 ** module id = 195
 ** module chunks = 0
 **/